import { render, staticRenderFns } from "./HotspotsTable.vue?vue&type=template&id=440bae70&scoped=true&"
import script from "./HotspotsTable.vue?vue&type=script&lang=js&"
export * from "./HotspotsTable.vue?vue&type=script&lang=js&"
import style0 from "./HotspotsTable.vue?vue&type=style&index=0&id=440bae70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440bae70",
  null
  
)

export default component.exports